import { SimNaoEnum } from 'components/form'
import { MChatInput, MChatPerguntaEnum } from 'graphql/types.generated'
import { isEmpty } from 'lodash'
import { isUndefinedOrNull } from 'util/checks'

import { MChatAplicacaoModel, MChatFieldModel, MChatQueryModel, MChatViewModel } from './model-mchat'
import { PERGUNTAS_RISCO_NAO, PERGUNTAS_RISCO_SIM } from './utils-mchat'

export const convertMChatToPerguntaRespostaInput = (mchat: MChatFieldModel): MChatInput['aplicacaoMChatR'] => {
  if (isEmpty(mchat)) return null
  return Object.entries(mchat.aplicacao)
    .filter(([, resposta]: [MChatPerguntaEnum, SimNaoEnum]) => !isUndefinedOrNull(resposta))
    .map(([pergunta, resposta]: [MChatPerguntaEnum, SimNaoEnum]) => ({
      pergunta,
      stPassou:
        (PERGUNTAS_RISCO_NAO.includes(pergunta) && resposta === SimNaoEnum.SIM) ||
        (PERGUNTAS_RISCO_SIM.includes(pergunta) && resposta === SimNaoEnum.NAO),
    }))
}

const convertMChatQueryToAplicacaoModel = (values: MChatQueryModel['aplicacao']): MChatAplicacaoModel => {
  return Object.fromEntries(
    values.map(({ pergunta, stPassou }) => [
      pergunta,
      (PERGUNTAS_RISCO_SIM.includes(pergunta) && !stPassou) || (PERGUNTAS_RISCO_NAO.includes(pergunta) && stPassou)
        ? SimNaoEnum.SIM
        : SimNaoEnum.NAO,
    ])
  ) as MChatAplicacaoModel
}

export const convertMChatQueryToViewModel = (mchat: MChatQueryModel): MChatViewModel => {
  if (isEmpty(mchat)) return null

  return {
    risco: mchat.risco,
    resultado: mchat.pontuacao,
    aplicacao: convertMChatQueryToAplicacaoModel(mchat.aplicacao),
    footerInfo: {
      dataResultado: mchat?.dataResultado,
      lotacao: {
        profissional: {
          nome: mchat?.atendimentoProfissional?.lotacao?.profissional?.nome,
          nomeSocial: mchat?.atendimentoProfissional?.lotacao?.profissional?.nomeSocial,
        },
        cbo: {
          nome: mchat?.atendimentoProfissional?.lotacao?.cbo?.nome,
        },
      },
      atendimentoProfissionalId: mchat?.atendimentoProfissional?.id,
    },
  }
}

export const convertMChatFieldToViewModel = (mchat: MChatFieldModel): MChatViewModel => {
  if (isEmpty(mchat)) return null

  return {
    risco: mchat.risco,
    resultado: mchat.resultado,
    aplicacao: mchat.aplicacao,
  }
}
